import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Home from '@/components/Home';
import RequestPassword from '@/components/RequestPassword';
import ChangePassword from '@/components/ChangePassword';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.ROUTER_PREFIX,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn) {
          next({
            path: '/',
          });
        } else {
          next();
        }
      },
    },
    {
      path: '/request_password',
      name: 'request_password',
      component: RequestPassword,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn) {
          next({
            path: '/',
          });
        } else {
          next();
        }
      },
    },
    {
      path: '/change_password',
      name: 'change_password',
      component: ChangePassword,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn) {
          next({
            path: '/',
          });
        } else {
          next();
        }
      },
    },
    {
      path: '*',
      component: {
        functional: true,
        render(h) {
          return h('h1', 'Page not found!');
        },
      },
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn) {
          next({
            path: '/',
          });
        } else {
          next({
            path: '/login',
          });
        }
      },
    },
  ],
});

// authenticate logged in user for each route that requires auth.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js